var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workflow-process"},_vm._l((_vm.nodes),function(node){return _c('process-node',{key:node.id,attrs:{"node":node}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }